import { Box, CircularProgress, DialogActions, DialogTitle, IconButton, TextField, Typography } from '@material-ui/core'
import React from 'react'

import { makeStyles } from '@material-ui/core'
import CustomDialog from '../CustomDialog'
import CustomButton from '../CustomButton'
import CustomLabel from '../CustomLabel'
import { Close } from '@material-ui/icons'
import CustomHeading from '../CustomHeading'
import CustomInput from '../CustomInput'

const useStyles = makeStyles((theme) => ({
  image: {
    width: '80px',
  },
  button: {
    // marginRight: '10px',
    width: '140px',
    // padding: '5px',
    backgroundColor: 'grey',
    '&:hover': {
      backgroundColor: 'grey',
    },
  },
  button2: {
    // marginRight: '10px',
    width: '140px',
    // padding: '5px',
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: theme.palette.error.main,
    },
  },
  dialog: {
    padding: '0px',
    minWidth: '463px',
  },
  iconButton: { position: 'relative', top: '-27px', left: '18px' },
  success: {
    // marginRight: '10px',
    width: '140px',
    // padding: '5px',
    backgroundColor: theme.palette.success.main,
    '&:hover': {
      backgroundColor: theme.palette.success.main,
    },
  },
  margn: {
    margin: 0,
  },
}))

export default function ApproveDialog({
  open,
  handleClose,
  name,
  handleSubmit,
  approve,
  loading,
  adminReason,
  setAdminReason,
}) {
  const classes = useStyles()
  return (
    <CustomDialog open={open} handleClose={handleClose} className={classes.dialog}>
      <Box display="flex" justifyContent="space-between">
        <CustomHeading heading="Leave Request" />
        <IconButton color="inherit" onClick={handleClose} className={classes.iconButton}>
          <Close />
        </IconButton>
      </Box>
      {approve && (
        <DialogTitle id="alert-dialog-title">
          Are you sure you want to {approve ? 'Approve Leave Request For ' : 'Decline Leave Request For '}
          <b>
            <i> {name} </i>
          </b>
          ?
        </DialogTitle>
      )}
      {!approve && (
        <Box display="flex" justifyContent="space-between" flexDirection="column">
          <Typography style={{ fontWeight: 600, fontSize: '14px' }}>{'Remark'}</Typography>
          <TextField
            type={'text'}
            value={adminReason}
            onChange={(e) => setAdminReason(e.target.value)}
            // label={label}
          />
        </Box>
      )}

      {/* <CustomInput value={adminReason} handleChange={setAdminReason} label="Remark" className={classes.margn} /> */}
      {!approve && <br />}
      {<br />}
      {/* <br /> */}

      <Box display="flex" justifyContent="space-evenly">
        <CustomButton text="Cancel" handleSubmit={handleClose} className={classes.button} />
        <CustomButton
          disabled={loading}
          text={loading ? <CircularProgress size="25px" color="inherit" /> : approve ? 'Approve' : 'Decline'}
          handleSubmit={approve ? () => handleSubmit('APPROVED') : () => handleSubmit('REJECTED')}
          className={approve ? classes.success : classes.button2}
        />
      </Box>
    </CustomDialog>
  )
}
